// extracted by mini-css-extract-plugin
export default {"center":"styles_center__4+Vcu"};